import { render, staticRenderFns } from "./DiskusiFilter.vue?vue&type=template&id=1bdeb31c&scoped=true"
import script from "./DiskusiFilter.vue?vue&type=script&lang=js"
export * from "./DiskusiFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdeb31c",
  null
  
)

export default component.exports